import React, { Component } from 'react';
import shuffleGrid from './shuffleGrid';

export default class Demo extends Component {
  constructor (props) {
    super();
    const grid = [];
    const w = props.width;
    const h = props.height;
    for (let col = 0; col < w; col += 1) {
      for (let row = 0; row < h; row += 1) {
        grid[row] = grid[row] || [];
        grid[row][col] = col/w * 360;
      }
    }

    shuffleGrid(grid);
    this.state = {
      slideValue: props.algorithm && props.algorithm.delayController ?
        props.algorithm.delayController.N : 1,
      grid,
      sortState: grid.map(() => {
        return {
          notSorted: true,
          i: 0,
          swaps: 0,
        };
      })
    }
    this.doStepWrapper = this.doStepWrapper.bind(this);
  }
  doStepWrapper = () => {
    if (!this.state.finished) {
      requestAnimationFrame(() => {
        this.paint();
        this.doStepWrapper()
      });
    }
  }
  paint() {
    const w = this.props.width;
    const h = this.props.height;
    for (let col = 0; col < w; col += 1) {
      for (let row = 0; row < h; row += 1) {
        if (this.state.sortState[row].notSorted) {
          this.c.fillStyle = `hsla(${this.state.grid[row][col]}, 100%, 50%, .8`;
          this.c.fillRect(col, row, 1, 1);
        }
      }
    }
  }
  componentDidMount () {
    const self = this;
    requestAnimationFrame(this.doStepWrapper)
    requestAnimationFrame(() => {
      this.state.grid.forEach((row) => {
        console.log('starting sort')
        self.props.sortAlgorithm.algorithm.sort(row);
        console.log('finish sort')
      })
    })
  }
  setRef = (canvas) => {
    this.canvas = canvas;
    this.c = canvas.getContext('2d');
  }
  onSlider = (e) => {
    let v = Number(e.target.value);
    v = isNaN(v) ? 1 : v;
    this.setState({
      slideValue: v,
    })
    this
      .props
      .sortAlgorithm
      .algorithm
      .delayController
      .setStepsPerFrame(v)
  }
  render() {
    return (
      <div>
        <div>
          {this.props.sortAlgorithm.title}
        </div>
        <div>
          <input
              value={this.state.slideValue}
              type="range"
              min="1"
              max="500"
              step="1"
              onChange={this.onSlider}
            />
            <span>
              {this.state.slideValue}
            </span>
          </div>
        <canvas
          width={this.props.width}
          height={this.props.height}
          ref={this.setRef}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Demo.js